import React, { useCallback, useEffect, useRef } from 'react';
import style from './circle.mod.scss';
import Lottie from '@lottielab/lottie-player/react';

const Circle = () => {
  const playerRef = useRef(null);
  const scrollTimeoutRef = useRef(null); // Reference to store the timeout ID

  const animate = useCallback(() => {
    return (
      <div className={style.circle}>
        <Lottie
          ref={playerRef}
          src="https://cdn.lottielab.com/l/EXrkeLJtY3iTsU.json"
          speed={0.5}
          autoplay={false} // Disable autoplay
          loop={false}
        />
      </div>
    );
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (playerRef.current) {
        playerRef.current.play(); // Start playing the animation
      }
    };

    window.addEventListener('scroll', handleScroll);
  }, []);

  return animate();
};

export default Circle;
